export default "__VITE_ASSET__Do66ayq7__"